import { supabase } from './supabase';

export async function uploadFile(bucket, pathPrefix, file, onProgress) {
  const ext = file.name.split('.').pop();
  const path = `${pathPrefix}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  if (onProgress) onProgress(10);

  const { error } = await supabase.storage.from(bucket).upload(path, file, {
    cacheControl: '3600',
    upsert: false,
  });

  if (error) throw error;
  if (onProgress) onProgress(100);

  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
}

export async function deleteStorageFile(bucket, fileUrl) {
  if (!fileUrl) return;
  const marker = `/storage/v1/object/public/${bucket}/`;
  const idx = fileUrl.indexOf(marker);
  if (idx === -1) return;
  const path = decodeURIComponent(fileUrl.slice(idx + marker.length));
  await supabase.storage.from(bucket).remove([path]);
}
